import type { DeliveryStrategy } from '@mimir/client-common/fileSync/downloadIdentity';
import type { ProjectItemUpdate } from '@mimir/primitive/nle/update';
import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import { invariant } from '@mimir/common/util/invariant';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';


export async function deliverPremiereItemUpdate(
  adobeContext: AdobePanelContext | ElectronContext,
  ongoingDownload: OngoingDownload,
  deliver: DeliveryStrategy,
  locallyAvailablePath: string,
) {
  const dlId = ongoingDownload.dlId;
  invariant(dlId, 'Expected download identity');
  invariant(deliver?.type == 'DeliverPremiereItemUpdate', 'Expected DeliverPremiereItemUpdate plan');
  const update: ProjectItemUpdate = {
    meta: {}
  };
  update[dlId.artefact == 'proxy' ? 'proxyMediaPath' : 'hiresMediaPath'] = locallyAvailablePath;
  await adobeContext.cepBridgeClient.call('updateProjectItem', deliver.itemRef, update);
}
